enum MedicalRequestType {
    ConsultationRequest,
    LabRequest
}

export { MedicalRequestType };
